import { defineComponent, reactive } from '@vue/composition-api';
export default defineComponent({
    props: ['title', 'disabled'],
    setup() {
        // ================
        //
        // state
        //
        let s = reactive({
            dialog: false,
            loading: false,
            callback: null
        });
        // ================
        //
        // methods
        //
        let open = (callback) => {
            s.dialog = true;
            s.callback = callback;
        };
        let close = () => {
            s.dialog = false;
            s.loading = false;
            s.callback = null;
        };
        let agree = () => {
            s.loading = true;
            s.callback(() => close());
        };
        // ================
        //
        // done
        //
        return {
            s,
            open,
            close,
            agree
        };
    }
});
